import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function FormInput({ bootstrapIcon, title, children }) {
    return (
        <div className="customInput">
            <h3 className="titleStyle2">{title}</h3>
            <div className="input-group">
                <div className="input-group-prepend">
                    <span
                        className={`input-group-text ${bootstrapIcon}`}
                    ></span>
                    {children}
                </div>
            </div>
        </div>
    );
}

FormInput.propTypes = {
    // icon displayed besides form input
    bootstrapIcon: PropTypes.string,
    // title displayed on top of input (form label)
    title: PropTypes.string,
    // components to be rendered inside
    children: PropTypes.node,
};

FormInput.defaultProps = {
    bootstrapIcon: 'icon-flag',
    title: 'Challenges',
    children: null,
};

export default FormInput;
